import {
  SettingsFormControl,
  TextInputField
} from '@sequencehq/core-components'

import { Merchant, useMerchantSettings } from './useMerchantSettings'
import { BASE_INPUT_FIELD_STYLES } from 'SettingsV2/settings.constants'

export const MerchantSupportSettings = (props: { merchant: Merchant }) => {
  const { getInputFieldProps } = useMerchantSettings(props.merchant)
  return (
    <>
      <SettingsFormControl label="Support email" htmlFor="support-email">
        <TextInputField
          type="email"
          {...BASE_INPUT_FIELD_STYLES}
          {...getInputFieldProps('supportEmail', {
            label: 'Support email',
            id: 'support-email',
            placeholder: 'hello@example.com'
          })}
        />
      </SettingsFormControl>
      <SettingsFormControl label="Support URL" htmlFor="support-url">
        <TextInputField
          {...BASE_INPUT_FIELD_STYLES}
          {...getInputFieldProps('supportUrl', {
            label: 'Support URL',
            id: 'support-url',
            placeholder: 'https://'
          })}
        />
      </SettingsFormControl>
    </>
  )
}
